import { Component, inject } from '@angular/core';
import { TimeSlotService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TimeSlotCreateDto,
  TimeSlotDto,
  TimeSlotExcelDownloadDto,
  TimeSlotUpdateDto,
} from '../proxy/general/dtos/time-slot';
import { TIMESLOT_CONFIG, TIMESLOT_FIELDS } from './time-slot.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-time-slot',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TimeSlotService, ConfirmationService],
  templateUrl: './time-slot.html',
  styleUrl: './time-slot.scss',
})
export class TimeSlot extends BaseCrudComponent<
  TimeSlotDto,
  TimeSlotCreateDto,
  TimeSlotUpdateDto,
  TimeSlotExcelDownloadDto
> {
  service = inject(TimeSlotService);
  config = TIMESLOT_CONFIG;
  fields = TIMESLOT_FIELDS;

  protected prepareUpdateDto(data: any, selected: TimeSlotDto): TimeSlotUpdateDto {
    return {
      slot: data.slot,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'TimeSlot';
  }
}
